import { Routes } from '@angular/router';
import { AuthPublicGuard } from '@app/auth/guards';
import { MsalGuard } from '@azure/msal-angular';

export const APP_ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadChildren: () => import('./welcome/welcome.routes').then((m) => m.WELCOME_ROUTES),
    canActivate: [AuthPublicGuard],
  },
  {
    path: 'essiloradmin',
    loadChildren: () =>
      import('./essilor-admin-feature/essilor-admin-feature.module').then((m) => m.EssilorAdminFeatureModule),
    data: { title: 'Essilor Admin' },
    canActivate: [MsalGuard],
  },
  {
    path: 'orders',
    loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
    data: { title: 'My Orders' },
    canActivate: [MsalGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
    data: { title: 'Glossary' },
    canActivate: [MsalGuard],
  },
  {
    path: 'announcements',
    loadChildren: () => import('./announcements/announcements.routes').then((m) => m.ANNOUNCEMENTS_ROUTES),
    data: { title: 'Announcements' },
    canActivate: [MsalGuard],
  },
  {
    path: 'support',
    loadChildren: () => import('./support/support.routes').then((m) => m.SUPPORT_ROUTES),
    data: { title: 'Support Center' },
    canActivate: [],
  },
  { path: '**', redirectTo: '/login' },
];
